import './App.css';
import Todolist from './components/Todolist';
import 'bootstrap/dist/css/bootstrap.min.css';
function App() {
  return (
    <div className="App">
       <Todolist/>
    </div>
  );
}

export default App;
